import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { X, Briefcase, MapPin, Calendar, ExternalLink } from 'lucide-react'
import { useStore } from '../../store/useStore'

const JobBanner = () => {
  const { jobPostings } = useStore()
  const [currentJob, setCurrentJob] = useState(null)
  const [isVisible, setIsVisible] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)

  useEffect(() => {
    // Trouver le dernier poste d'emploi actif
    const activeJobs = jobPostings.filter(job => 
      job.status === 'active' && 
      new Date(job.createdAt) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) // Derniers 7 jours
    )
    
    if (activeJobs.length > 0) {
      const latestJob = activeJobs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]
      setCurrentJob(latestJob)
      
      // Vérifier si l'utilisateur a déjà fermé cette bannière
      const dismissedKey = `job_banner_dismissed_${latestJob.id}`
      const wasDismissed = localStorage.getItem(dismissedKey)
      
      if (!wasDismissed) {
        setIsVisible(true)
      }
    }
  }, [jobPostings])

  const handleDismiss = () => {
    setIsDismissed(true)
    if (currentJob) {
      localStorage.setItem(`job_banner_dismissed_${currentJob.id}`, 'true')
    }
  }

  const handleApply = () => {
    // Rediriger vers la page de candidature
    window.open(`/jobs/${currentJob.id}`, '_blank')
  }

  if (!currentJob || !isVisible || isDismissed) {
    return null
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -100 }}
        transition={{ duration: 0.5 }}
        className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-green-600 to-blue-600 text-white shadow-lg"
      >
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <Briefcase size={20} />
                <span className="font-semibold">Nouveau Poste Disponible !</span>
              </div>
              
              <div className="hidden md:flex items-center space-x-4 text-sm">
                <div className="flex items-center space-x-1">
                  <MapPin size={16} />
                  <span>{currentJob.location}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Calendar size={16} />
                  <span>{new Date(currentJob.createdAt).toLocaleDateString('fr-FR')}</span>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <button
                onClick={handleApply}
                className="bg-white text-green-600 px-4 py-1 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors flex items-center space-x-1"
              >
                <span>Postuler</span>
                <ExternalLink size={14} />
              </button>
              
              <button
                onClick={handleDismiss}
                className="text-white hover:text-gray-200 transition-colors"
              >
                <X size={20} />
              </button>
            </div>
          </div>
          
          {/* Titre du poste sur mobile */}
          <div className="md:hidden mt-2">
            <h3 className="font-semibold text-sm">{currentJob.title}</h3>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  )
}

export default JobBanner
